import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ZoomableService } from '../services/zoomable.service';

@Component({
  template: '',
})
export class ZoomableLayerComponent implements OnInit, OnDestroy {
  @Input() public zoomId: string;
  @Input() public showContentOnce: boolean = false;

  public isZoomEnabled = false;
  public showContentCounter = 0;
  public showContent = true;

  private zoomOutSubscription: Subscription = Subscription.EMPTY;
  private zoomInSubscription: Subscription = Subscription.EMPTY;
  private nativeElement: HTMLElement;

  public constructor(protected zoomableService: ZoomableService, protected elementRef: ElementRef) {
    this.nativeElement = this.elementRef.nativeElement;
  }

  public ngOnInit(): void {
    this.zoomOutSubscription = this.zoomableService.zoomOut$.subscribe((state) => {
      if (this.zoomId !== state.zoomId) {
        return;
      }

      this.disableZoom();
    });

    this.zoomInSubscription = this.zoomableService.zoomIn$.subscribe((state) => {
      if (this.zoomId !== state.zoomId) {
        return;
      }

      this.enableZoom();
    });
  }

  public ngOnDestroy(): void {
    if (this.zoomOutSubscription !== Subscription.EMPTY) {
      this.zoomOutSubscription.unsubscribe();
      this.zoomOutSubscription = Subscription.EMPTY;
    }

    if (this.zoomInSubscription !== Subscription.EMPTY) {
      this.zoomInSubscription.unsubscribe();
      this.zoomInSubscription = Subscription.EMPTY;
    }
  }

  @HostListener('click')
  public onClick(): void {
    this.zoomableService.zoomIn$.emit({ zoomId: this.zoomId, match: true, scale: null });
  }

  private enableZoom(): void {
    this.nativeElement.style['z-index'] = '100';
    this.nativeElement.style['position'] = 'absolute';
    this.isZoomEnabled = true;
  }

  private disableZoom(): void {
    this.nativeElement.style['z-index'] = null;
    this.nativeElement.style['position'] = 'static';
    this.isZoomEnabled = false;
    if (this.showContentOnce) {
      this.showContentOnce = this.showContent = false;
    }
  }
}
